var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-height pa-3", attrs: { id: "meeting_participant" } },
    [
      _c(
        "v-overlay",
        {
          attrs: {
            value: _vm.joining && !_vm.isLobby,
            opacity: "1",
            color: "background",
            absolute: true,
          },
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "primary" },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          staticClass: "text-center",
          attrs: { value: _vm.isLobby, color: "header", opacity: "1" },
        },
        [
          _c("v-img", {
            staticStyle: { margin: "auto" },
            attrs: {
              src: _vm.app.room.settings.header_logo,
              "max-height": "150",
              "max-width": "150",
              contain: "",
              position: "center",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                "min-width": "300px",
                "max-width": "90%",
                margin: "auto",
              },
            },
            [
              _c("div", { staticClass: "mt-16 mb-8" }, [
                _c("div", { staticClass: "text-h5 text-md-h3" }, [
                  _c("span", [
                    _vm._v(
                      "Hello" +
                        _vm._s(_vm.name.length > 0 ? `, ${_vm.name}` : "!")
                    ),
                  ]),
                ]),
              ]),
              _c("v-text-field", {
                staticClass: "mt-16",
                attrs: {
                  label: "Please Enter Your Name for the Meeting",
                  "x-large": "",
                  color: _vm.app.headerIsDark() ? "white" : "black",
                  outlined: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _vm.name.length > 0
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                on: { click: _vm.saveLobbyName },
                              },
                              [_c("v-icon", [_vm._v("mdi-check-circle")])],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          true || _vm.say_hello
            ? _c(
                "div",
                {
                  staticClass: "text-h6",
                  attrs: { color: _vm.app.headerIsDark() ? "white" : "black" },
                },
                [_vm._v(" Please wait. Your meeting will begin shortly. ")]
              )
            : _c("div", { staticClass: "text-h6" }, [_vm._v(" ")]),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          staticClass: "text-center",
          attrs: { color: "header", value: _vm.meeting.leaving, opacity: "1" },
        },
        [
          _vm.app.room.settings.exit_image
            ? _c("v-img", {
                attrs: {
                  src: _vm.app.room.settings.exit_image,
                  "max-height": "500",
                  "max-width": "800",
                  contain: "",
                  position: "center",
                },
              })
            : _c("v-img", {
                attrs: {
                  src: _vm.app.room.settings.header_logo,
                  "max-height": "150",
                  "max-width": "90vw",
                  contain: "",
                  position: "center",
                },
              }),
          _c(
            "v-btn",
            {
              staticClass: "mt-6 primary rounded font-weight-light elevation-0",
              attrs: { large: "" },
              on: {
                click: function ($event) {
                  return _vm.navToExitUrl()
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.app.room.settings.exit_button_text
                      ? _vm.app.room.settings.exit_button_text
                      : "Create Your Own Account Now"
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "text-center mt-4" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    color: _vm.app.headerIsDark() ? "white" : "black",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.join()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-arrow-left")]), _vm._v(" Rejoin ")],
                1
              ),
              _vm.userIsLoggedIn()
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: _vm.app.headerIsDark() ? "white" : "black",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({ path: "/admin" })
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("mdi-cog"),
                      ]),
                      _vm._v(" Admin "),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          ref: "video_container",
          attrs: {
            absolute: true,
            color: "background",
            value:
              !_vm.isLobby &&
              !_vm.joining &&
              !_vm.meeting.leaving &&
              !_vm.meeting.is_connected &&
              (_vm.showJoinForm || _vm.showPreview),
            opacity: "1",
          },
        },
        [
          _vm.token && !_vm.error
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "rounded-lg ma-2",
                          staticStyle: { margin: "auto" },
                          attrs: {
                            elevation: "0",
                            width: "400",
                            "max-width": "100vw",
                            loading: _vm.isLoadingVideoPlugin,
                          },
                        },
                        [
                          !_vm.isLivestreamViewer
                            ? _c(
                                "v-responsive",
                                {
                                  ref: "preview_container",
                                  attrs: { "aspect-ratio": 4 / 3 },
                                },
                                [
                                  _vm.meeting.local_peer &&
                                  _vm.meeting.local_peer.videoTrack
                                    ? _c("video", {
                                        key: _vm.preview_video_key,
                                        ref: "preview_video",
                                        staticClass: "mirror",
                                        attrs: {
                                          autoplay: "",
                                          playsinline: "",
                                          width: "100%",
                                        },
                                        domProps: { muted: true },
                                      })
                                    : _vm.meeting.local_peer &&
                                      _vm.meeting.local_peer.roleName != "qa"
                                    ? _c("v-skeleton-loader", {
                                        staticClass: "mx-auto rounded-lg",
                                        attrs: {
                                          "max-width": "100%",
                                          "max-height": "350",
                                          type: "image, image",
                                        },
                                      })
                                    : _c(
                                        "v-overlay",
                                        { attrs: { absolute: true } },
                                        [
                                          _vm.meeting.local_peer &&
                                          _vm.meeting.local_peer.roleName ==
                                            "qa"
                                            ? _c("span", [
                                                _vm._v(
                                                  "Audio and Video are turned off for QAs"
                                                ),
                                              ])
                                            : _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  size: "48",
                                                },
                                              }),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-card-text",
                            [
                              _vm.show_admin_login
                                ? _c(
                                    "v-row",
                                    { staticClass: "mt-2" },
                                    [
                                      _vm.show_admin_login
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "Email",
                                                  "hide-details": "auto",
                                                },
                                                model: {
                                                  value: _vm.admin_email,
                                                  callback: function ($$v) {
                                                    _vm.admin_email = $$v
                                                  },
                                                  expression: "admin_email",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.show_admin_login
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "Password",
                                                  "hide-details": "auto",
                                                  type: "password",
                                                },
                                                model: {
                                                  value: _vm.admin_password,
                                                  callback: function ($$v) {
                                                    _vm.admin_password = $$v
                                                  },
                                                  expression: "admin_password",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                "x-large": "",
                                                block: "",
                                                loading: _vm.is_logging_in,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.doLogin()
                                                },
                                              },
                                            },
                                            [_vm._v("Login")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-row",
                                    { staticClass: "mt-2" },
                                    [
                                      _vm.isLivestreamViewer ||
                                      (_vm.meeting.local_peer &&
                                        _vm.meeting.local_peer.roleName)
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "Display Name",
                                                  "hide-details": "auto",
                                                },
                                                model: {
                                                  value: _vm.name,
                                                  callback: function ($$v) {
                                                    _vm.name = $$v
                                                  },
                                                  expression: "name",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.app.room.settings.show_email_field &&
                                      (_vm.userIsGuest() ||
                                        _vm.isLivestreamViewer)
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "Email Address",
                                                  "hide-details": "auto",
                                                  rules: _vm.app.room.settings
                                                    .require_email_field
                                                    ? [
                                                        _vm.rules.email,
                                                        _vm.rules.required,
                                                      ]
                                                    : [_vm.rules.email],
                                                },
                                                model: {
                                                  value: _vm.email_address,
                                                  callback: function ($$v) {
                                                    _vm.email_address = $$v
                                                  },
                                                  expression: "email_address",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.app.room.settings.password &&
                                      (_vm.userIsGuest() ||
                                        _vm.isLivestreamViewer)
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  outlined: "",
                                                  label: "Password",
                                                  "hide-details": "auto",
                                                },
                                                model: {
                                                  value: _vm.password,
                                                  callback: function ($$v) {
                                                    _vm.password = $$v
                                                  },
                                                  expression: "password",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.isLivestreamViewer ||
                                      (_vm.meeting.local_peer &&
                                        _vm.meeting.local_peer.roleName)
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _vm.isLivestreamViewer
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "x-large": "",
                                                        block: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.join()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Join Livestream")]
                                                  )
                                                : _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        "x-large": "",
                                                        block: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.join()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Join as " +
                                                          _vm._s(
                                                            _vm.meeting
                                                              .local_peer
                                                              .roleName ==
                                                              "waiting-room"
                                                              ? "Guest"
                                                              : _vm.meeting
                                                                  .local_peer
                                                                  .roleName
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      true ||
                                      (_vm.meeting.local_peer &&
                                        _vm.meeting.local_peer.roleName)
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "text-center",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              !_vm.userIsLoggedIn()
                                                ? [
                                                    _vm.login_url
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: {
                                                              text: "",
                                                              href: _vm.login_url,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Admin Login"
                                                            ),
                                                          ]
                                                        )
                                                      : !_vm.show_admin_login
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: { text: "" },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.show_admin_login = true
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Admin Login"
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: { text: "" },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.show_admin_login = false
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Guest Login"
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                : _vm._e(),
                                              _vm.userIsLoggedIn()
                                                ? [
                                                    _vm.outsetaToken()
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: {
                                                              text: "",
                                                              href: _vm.logout_url,
                                                            },
                                                          },
                                                          [_vm._v("Log Out")]
                                                        )
                                                      : _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: { text: "" },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.doLogout()
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("Log Out")]
                                                        ),
                                                  ]
                                                : _vm._e(),
                                              _vm.userIsLoggedIn()
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "primary--text ml-3",
                                                      attrs: {
                                                        text: "",
                                                        href: "/account/",
                                                      },
                                                    },
                                                    [_vm._v("Admin")]
                                                  )
                                                : _vm._e(),
                                              !_vm.userIsLoggedIn() &&
                                              _vm.registration_url != ""
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "primary--text ml-3",
                                                      attrs: {
                                                        text: "",
                                                        href: _vm.registration_url,
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [_vm._v("Register")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.app.room.settings.profile_image ||
                  _vm.app.room.settings.profile_name
                    ? _c(
                        "v-col",
                        { staticClass: "d-none d-md-flex" },
                        [
                          _c("host-profile", {
                            attrs: { settings: _vm.app.room.settings },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm.error && _vm.error.code == "3001"
            ? _c(
                "v-overlay",
                {
                  attrs: { opacity: "1", color: "background", absolute: true },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      staticStyle: { width: "400px", "max-width": "90vw" },
                    },
                    [
                      _c("div", { staticClass: "text-h4 mb-4" }, [
                        _vm._v("Camera and Microphone"),
                        _c("br"),
                        _vm._v("Permissions are Missing"),
                      ]),
                      _c(
                        "div",
                        [
                          _vm.micEnabled == null
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-help-circle"),
                                  ]),
                                  _vm._v(" Microphone"),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.micEnabled
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "success", outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-check-circle"),
                                  ]),
                                  _vm._v(" Microphone"),
                                ],
                                1
                              )
                            : _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "error", outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-close-circle"),
                                  ]),
                                  _vm._v(" Microphone"),
                                ],
                                1
                              ),
                          _vm.cameraEnabled == null
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-help-circle"),
                                  ]),
                                  _vm._v(" Camera"),
                                ],
                                1
                              )
                            : _vm.cameraEnabled
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "success", outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-check-circle"),
                                  ]),
                                  _vm._v(" Camera"),
                                ],
                                1
                              )
                            : _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  attrs: { color: "error", outlined: "" },
                                },
                                [
                                  _c("v-icon", { staticClass: "mr-2" }, [
                                    _vm._v("mdi-close-circle"),
                                  ]),
                                  _vm._v(" Camera"),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _vm.browser.browser.name != "chrome"
                        ? _c(
                            "v-btn",
                            {
                              attrs: { "x-large": "", color: "error" },
                              on: {
                                click: function ($event) {
                                  return _vm.promptForDevicePermission()
                                },
                              },
                            },
                            [_vm._v("Try Again")]
                          )
                        : _c("div", [
                            _vm._v(
                              " Look for the camera icon in the address bar and click on it to allow access to your camera and microphone."
                            ),
                            _c("br"),
                            _vm._v("Then reload the page. "),
                          ]),
                      _vm.profilePhone != ""
                        ? _c("div", { staticClass: "mt-4 font-weight-bold" }, [
                            _vm._v(
                              "To join the meeting by phone, call " +
                                _vm._s(_vm.profilePhone) +
                                "."
                            ),
                          ])
                        : _vm._e(),
                      _c("v-text-field", {
                        staticClass: "my-4",
                        attrs: {
                          outlined: "",
                          label: "Display Name",
                          "hide-details": "auto",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", "x-large": "", block: "" },
                          on: {
                            click: function ($event) {
                              return _vm.join()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Join as " +
                              _vm._s(
                                _vm.meeting.local_peer.roleName ==
                                  "waiting-room"
                                  ? "Guest"
                                  : _vm.meeting.local_peer.roleName
                              )
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm.userIsLoggedIn() && !_vm.userCanJoinAs("host")
            ? [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v("SELECT YOUR ROLE FOR THIS MEETING"),
                ]),
                _c(
                  "v-card",
                  {
                    staticClass: "rounded-lg ma-2",
                    attrs: {
                      elevation: "10",
                      width: "500",
                      "max-width": "96vw",
                    },
                  },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          { attrs: { grow: "" } },
                          [
                            _vm.userIsRoomOwner()
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary", block: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectRole("host")
                                          },
                                        },
                                      },
                                      [_vm._v("Host")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.userCanJoinAs("coach")
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary", block: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectRole("coach")
                                          },
                                        },
                                      },
                                      [_vm._v("Coach")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.userCanJoinAs("qa")
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary", block: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectRole("qa")
                                          },
                                        },
                                      },
                                      [_vm._v("QA")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.userIsLoggedIn()
                              ? _c(
                                  "v-col",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { color: "primary", block: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectRole("guest")
                                          },
                                        },
                                      },
                                      [_vm._v("Guest")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "v-dialog",
        {
          attrs: { maxWidth: "600" },
          model: {
            value: _vm.meeting.show_settings,
            callback: function ($$v) {
              _vm.$set(_vm.meeting, "show_settings", $$v)
            },
            expression: "meeting.show_settings",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Settings")]),
              _c(
                "v-card-text",
                [
                  _c("v-select", {
                    staticClass: "mt-6",
                    attrs: {
                      label: "Video",
                      items: _vm.availableCameras(),
                      outlined: "",
                    },
                    model: {
                      value: _vm.selected_camera,
                      callback: function ($$v) {
                        _vm.selected_camera = $$v
                      },
                      expression: "selected_camera",
                    },
                  }),
                  _c("v-select", {
                    staticClass: "mt-4",
                    attrs: {
                      label: "Microphone",
                      items: _vm.availableMicrophones(),
                      outlined: "",
                    },
                    model: {
                      value: _vm.selected_microphone,
                      callback: function ($$v) {
                        _vm.selected_microphone = $$v
                      },
                      expression: "selected_microphone",
                    },
                  }),
                  _vm.userIsRoomOwner()
                    ? _c("v-select", {
                        staticClass: "mt-4",
                        attrs: {
                          label: "Room/Theme",
                          items: _vm.app.rooms,
                          "item-text": "post_title",
                          "item-value": (item) => item,
                          outlined: "",
                        },
                        model: {
                          value: _vm.app.room,
                          callback: function ($$v) {
                            _vm.$set(_vm.app, "room", $$v)
                          },
                          expression: "app.room",
                        },
                      })
                    : _vm._e(),
                  _c("v-switch", {
                    attrs: {
                      label: _vm.meeting.blur_on
                        ? "Background Blur On"
                        : "Background Blur Off",
                    },
                    on: {
                      change: function ($event) {
                        _vm.meeting.toggle_blur = true
                      },
                    },
                    model: {
                      value: _vm.meeting.blur_on,
                      callback: function ($$v) {
                        _vm.$set(_vm.meeting, "blur_on", $$v)
                      },
                      expression: "meeting.blur_on",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.meeting.show_settings = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.meeting.is_connected &&
      (!_vm.show_aux_track || _vm.isSharingScreen()) &&
      !_vm.meeting.isCobrowsing() &&
      !_vm.meeting.is_whiteboard_active
        ? _c(
            "v-row",
            [
              _vm._l(_vm.video_peers, function (peer, index) {
                return _c(
                  "v-col",
                  {
                    key: peer.id,
                    class: "pa-2 " + _vm.getValOrBlankColClass(index),
                    attrs: { cols: _vm.getValOrBlankCols(index) },
                  },
                  [
                    _vm.meeting.local_peer.roleName != "waiting-room" ||
                    peer.isLocal
                      ? _c(
                          "v-card",
                          {
                            staticClass: "rounded-lg",
                            attrs: {
                              loading: _vm.loading_video_plugin && peer.isLocal,
                            },
                          },
                          [
                            _vm.meeting.peer_video_enabled[peer.id]
                              ? _c("video", {
                                  ref: peer.id,
                                  refInFor: true,
                                  class: `rounded-lg ${
                                    _vm.grid[index] ? _vm.grid[index].class : ""
                                  } ${peer.isLocal ? " mirror" : ""}`,
                                  staticStyle: {
                                    "max-width": "100%",
                                    width: "100%",
                                    "object-fit": "cover",
                                    "margin-bottom": "-6px",
                                  },
                                  attrs: {
                                    "aspect-ratio": 16 / 9,
                                    autoplay: "",
                                    playsinline: "",
                                  },
                                  domProps: { muted: peer.isLocal },
                                })
                              : _c(
                                  "v-card",
                                  {
                                    staticStyle: {
                                      "max-width": "100%",
                                      "margin-bottom": "-6px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-responsive",
                                      {
                                        class: `rounded-lg ${
                                          _vm.grid[index]
                                            ? _vm.grid[index].class
                                            : ""
                                        }`,
                                        attrs: { "aspect-ratio": 16 / 9 },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "fill-height",
                                            staticStyle: {
                                              width: "100%",
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-h4 font-weight-bold",
                                              },
                                              [_vm._v(_vm._s(peer.name))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                            _c(
                              "v-overlay",
                              {
                                staticStyle: {
                                  "justify-content": "start",
                                  "align-items": "end",
                                },
                                attrs: { opacity: "0", absolute: true },
                              },
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mx-2 white--text mb-2",
                                    attrs: {
                                      color: `${
                                        peer.roleName == "coach"
                                          ? "orange"
                                          : "grey"
                                      } darken-4`,
                                      small: "",
                                    },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(peer.name) + " "),
                                    _vm.meeting.local_peer.roleName != "guest"
                                      ? _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                peer.roleName.toUpperCase()
                                              ) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-1 white--text",
                                        attrs: { icon: "", "x-small": "" },
                                        on: {
                                          click: function ($event) {
                                            ;["host", "coach"].includes(
                                              _vm.meeting.local_peer.roleName
                                            ) &&
                                              _vm.meeting.enablePeerAudio(
                                                peer,
                                                !_vm.meeting.peer_audio_enabled[
                                                  peer.id
                                                ]
                                              )
                                          },
                                        },
                                      },
                                      [
                                        !_vm.meeting.peer_audio_enabled[peer.id]
                                          ? _c(
                                              "v-icon",
                                              { attrs: { color: "red" } },
                                              [_vm._v("mdi-microphone-off")]
                                            )
                                          : _c("v-icon", [
                                              _vm._v("mdi-microphone"),
                                            ]),
                                      ],
                                      1
                                    ),
                                    _vm.meeting.permissions &&
                                    _vm.meeting.permissions.changeRole
                                      ? _c("meeting-participant-menu", {
                                          attrs: { peer: peer },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-overlay",
                              {
                                attrs: {
                                  absolute: true,
                                  value:
                                    peer.roleName == "waiting-room" &&
                                    ["host", "coach"].includes(
                                      _vm.meeting.local_peer.roleName
                                    ),
                                },
                              },
                              [
                                _vm.meeting.local_peer.roleName == "host"
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          "x-large": "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.meeting.hmsActions.changeRole(
                                              peer.id,
                                              "guest",
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " Admit " +
                                            _vm._s(peer.name.toUpperCase()) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.meeting.local_peer.roleName == "waiting-room"
                ? _c(
                    "v-col",
                    {
                      class:
                        "rounded-lg pa-2 pb-0 pl-0 " + _vm.grid[1].col_class,
                      staticStyle: {
                        "justify-content": "start",
                        "align-items": "top",
                      },
                      attrs: { cols: _vm.grid[1].cols },
                    },
                    [
                      _vm.app.room.settings.profile_image ||
                      _vm.app.room.settings.profile_name
                        ? _c("host-profile", {
                            attrs: { settings: _vm.app.room.settings },
                          })
                        : _vm._e(),
                      _vm.meeting.local_peer.roleName == "waiting-room"
                        ? _c(
                            "v-snackbar",
                            {
                              attrs: {
                                color: "primary",
                                timeout: "-1",
                                top: "",
                              },
                              model: {
                                value: _vm.show_waiting_for_host,
                                callback: function ($$v) {
                                  _vm.show_waiting_for_host = $$v
                                },
                                expression: "show_waiting_for_host",
                              },
                            },
                            [
                              _c("div", { staticClass: "text-center" }, [
                                _vm._v(" Waiting for Host "),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.show_aux_track && !_vm.isSharingScreen()
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        {
                          key: peer.id,
                          staticClass: "rounded-lg mb-2",
                          on: {
                            mouseover: function ($event) {
                              _vm.showNames = true
                            },
                            mouseleave: function ($event) {
                              _vm.showNames = false
                            },
                          },
                        },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-quarter-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected && _vm.showNames
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", [
                      _c("video", {
                        ref: "screenshare_video",
                        class: `rounded-lg video-full-height`,
                        staticStyle: {
                          "max-width": "100%",
                          width: "100%",
                          "object-fit": "contain",
                          "margin-bottom": "-36px",
                        },
                        attrs: {
                          "aspect-ratio": 16 / 9,
                          autoplay: "",
                          playsinline: "",
                        },
                      }),
                      _vm.show_video_playlist_item &&
                      _vm.meeting.video_playlist.length > 0
                        ? _c(
                            "div",
                            {
                              staticStyle: { "margin-top": "-18px" },
                              attrs: { opacity: "0" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    fab: "",
                                    small: "",
                                    elevation: "2",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVideoPlaylistItem()
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.video_playlist_item_paused
                                          ? "mdi-play"
                                          : "mdi-pause"
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-1",
                                  attrs: { fab: "", small: "", elevation: "2" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeVideoPlaylistItem()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-close")])],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.isLivestreaming &&
      _vm.meeting.local_peer &&
      _vm.meeting.local_peer.roleName == "livestream-viewer"
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("video", {
                      ref: "livestream_video",
                      class: `video-full-height`,
                      staticStyle: {
                        "max-width": "100%",
                        width: "100%",
                        "object-fit": "contain",
                        "margin-bottom": "-36px",
                      },
                      attrs: {
                        "aspect-ratio": 16 / 9,
                        autoplay: "",
                        playsinline: "",
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.is_connected &&
      _vm.meeting.cobrowse_session &&
      _vm.meeting.isCobrowsing()
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        { key: peer.id, staticClass: "rounded-lg mb-2" },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-sixth-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("iframe", {
                      staticClass: "video-full-height rounded-lg",
                      staticStyle: { width: "100%", "margin-bottom": "-36px" },
                      attrs: {
                        src:
                          _vm.meeting.local_peer.roleName == "host"
                            ? _vm.meeting.cobrowse_session.leader_link +
                              "?name=" +
                              _vm.meeting.local_peer.name
                            : _vm.meeting.cobrowse_session.follower_link +
                              "?name=" +
                              _vm.meeting.local_peer.name,
                        allow: "autoplay *; display-capture *; geolocation *;",
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.meeting.is_connected && _vm.meeting.is_whiteboard_active
        ? _c(
            "v-container",
            { staticClass: "mt-0 full-height pa-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "2" } },
                    _vm._l(_vm.video_peers, function (peer) {
                      return _c(
                        "v-card",
                        { key: peer.id, staticClass: "rounded-lg mb-2" },
                        [
                          _c("video", {
                            ref: peer.id,
                            refInFor: true,
                            class: `rounded-lg video-sixth-height ${
                              peer.isLocal ? " mirror" : ""
                            }`,
                            staticStyle: {
                              width: "100%",
                              "object-fit": "cover",
                              "margin-bottom": "-6px",
                            },
                            attrs: {
                              "aspect-ratio": 16 / 9,
                              autoplay: "",
                              playsinline: "",
                            },
                            domProps: { muted: peer.isLocal },
                          }),
                          _vm.meeting.is_connected
                            ? _c(
                                "v-overlay",
                                {
                                  staticStyle: {
                                    "justify-content": "start",
                                    "align-items": "end",
                                  },
                                  attrs: { absolute: true, opacity: "0" },
                                },
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "ma-1 white--text",
                                      attrs: {
                                        color: `${
                                          peer.roleName == "coach"
                                            ? "orange"
                                            : "grey"
                                        } darken-4`,
                                        small: "",
                                      },
                                    },
                                    [
                                      _vm._v(" " + _vm._s(peer.name) + " "),
                                      !_vm.meeting.peer_audio_enabled[peer.id]
                                        ? _c(
                                            "v-icon",
                                            {
                                              staticClass: "ml-2",
                                              attrs: { color: "red" },
                                            },
                                            [_vm._v("mdi-microphone-off")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          peer.roleName == "waiting-room" &&
                          ["host", "coach"].includes(
                            _vm.meeting.local_peer.roleName
                          )
                            ? _c(
                                "v-overlay",
                                { attrs: { absolute: true } },
                                [
                                  _vm.meeting.local_peer.roleName == "host"
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            "x-small": "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.meeting.hmsActions.changeRole(
                                                peer.id,
                                                "guest",
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Admit " +
                                              _vm._s(peer.name.toUpperCase()) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _c("v-col", { attrs: { cols: "10" } }, [
                    _c("div", {
                      staticClass: "video-full-height rounded-lg",
                      staticStyle: { width: "100%", "margin-bottom": "-36px" },
                      attrs: { id: "wt-container" },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          staticStyle: { cursor: "pointer" },
          attrs: {
            centered: !!_vm.app.snackbar.settings.centered,
            color: _vm.app.snackbar.settings.color,
            top: !!_vm.app.snackbar.settings.top,
            right: !!_vm.app.snackbar.settings.right,
            timeout: _vm.app.snackbar.timeout,
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.app.snackbar.settings.show = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_c("v-icon", [_vm._v("mdi-close-circle")])],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.app.snackbar.settings.show,
            callback: function ($$v) {
              _vm.$set(_vm.app.snackbar.settings, "show", $$v)
            },
            expression: "app.snackbar.settings.show",
          },
        },
        [
          _c(
            "span",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSnackbarClick(
                    _vm.app.snackbar.settings.click
                  )
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.app.snackbar.settings.message) + " ")]
          ),
        ]
      ),
      _c("v-overlay", {
        attrs: {
          value:
            _vm.meeting.is_connected &&
            _vm.meeting.local_peer &&
            ["coach", "qa"].includes(_vm.meeting.local_peer.roleName) &&
            _vm.meeting.isCobrowsing(),
          absolute: true,
          opacity: "0",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }